export default "__VITE_ASSET__D4NQ2LJD__"